import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Logo,
  Link,
  TextField,
  Button,
  PageSelector,
  ErrorMessage,
  SelectorButtonSection,
  MainFormSection,
} from '../../components/_layouts/forms/styles';
import Loading from '../../components/Loading';
import { signinRequest } from '../../store/modules/auth/actions';

import logo from '../../images/Logo.png';

export default function SignIn() {
  const [email, updateEmail] = useState('');
  const [password, updatePassword] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const hasError = useSelector((state) => state.auth.hasError);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await dispatch(signinRequest({ email, password }));
  };

  const handleOnClick = () => history.push('/signup');

  return (
    <>
      <Container>
        <SelectorButtonSection>
          <PageSelector>Login</PageSelector>
          <PageSelector id="not-selected" onClick={() => handleOnClick()}>
            Cadastre-se
          </PageSelector>
        </SelectorButtonSection>

        <MainFormSection>
          <Logo src={logo} alt="Logo tvpersonal" />
          <form onSubmit={(event) => handleSubmit(event)}>
            <TextField
              fullWidth
              label="E-mail"
              value={email}
              variant="outlined"
              onChange={(event) => updateEmail(event.target.value)}
            />

            <TextField
              fullWidth
              label="Senha"
              value={password}
              type="password"
              variant="outlined"
              onChange={(event) => updatePassword(event.target.value)}
            />
            {hasError ? (
              <ErrorMessage>
                E-mail ou senha incorretos! Tente novamente.
              </ErrorMessage>
            ) : null}

            <Button
              disabled={isLoading}
              fullWidth
              type="submit"
              variant="outlined"
            >
              Entrar
              {isLoading && <Loading buttonLoading />}
            </Button>

            <Link to="/password-recovery">Esqueci minha senha</Link>
          </form>
        </MainFormSection>
      </Container>
    </>
  );
}
